/* eslint-disable no-param-reassign */
import { put, takeEvery } from 'redux-saga/effects'

import { Messages } from '../Socket'
import { ControlsCreators, SocketCreators, TrackingCreators } from '../../actions'

import config from '../Config'

export function* sendNewChatRequest({ brand, department }) {
  const newChatRequestMessage = Messages.newChatRequest({ brand, department })
  yield put(SocketCreators.sendSocketMessage(newChatRequestMessage))
}

export function* sendRenewChatRequest({ chatId, authenticationKey }) {
  const renewChatRequestMessage = Messages.renewChatRequest({ chatId, authenticationKey })
  yield put(SocketCreators.sendSocketMessage(renewChatRequestMessage))
}

export function* newStage(action) {
  const { stage = '' } = action.result
  const control = config.stagesToControl[stage]
  if (control) {
    yield put(ControlsCreators.setActiveControl(control))
  }
  if (stage === config.stages.WAIT) {
    yield put(TrackingCreators.trackWaitingRoom())
  }
  if (stage === config.stages.BOT_CHAT) {
    yield put(TrackingCreators.trackBotConnected())
  }
}

export function* endChat({ result }) {
  // 101 - TOO_BUSY
  if (result.status === 101) {
    yield put(TrackingCreators.trackWaitingRoomTooBusy())
  }
}

/**
 * Watcher
 */

export default [
  takeEvery('SEND_NEW_CHAT_REQUEST', sendNewChatRequest),
  takeEvery('SEND_RENEW_CHAT_REQUEST', sendRenewChatRequest),

  takeEvery('NEW_STAGE', newStage),
  takeEvery('END_CHAT', endChat),
]
